import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import Backend from 'i18next-http-backend';
import {createContext, FC, ReactNode, useEffect} from "react";
import {useAuth} from "./firebase/firebaseAuth";

const localStorageLanguageKey = "language";
i18n
  .use(I18nextBrowserLanguageDetector)
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'pl-PL',
    debug: true,
    lng: 'pl-PL',
    backend: {
      requestOptions: {
        cache: 'no-cache'
      }
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });
type changeLanguageType = {
  changeLanguage: (iso: LanguagesType) => void
  i18n: typeof i18n
}
export const Languages = ["pl-PL", "en-US"] as const;
export type LanguagesType = typeof Languages[number];

export const I18Context = createContext<changeLanguageType>({
  changeLanguage: (iso: LanguagesType) => i18n.changeLanguage(iso),
  i18n
});

type i18ProviderProviderProps = {
  children: ReactNode
}
export const I18nProvider: FC<i18ProviderProviderProps> = ({children}) => {
  const {userData, updateUserData} = useAuth()
  useEffect(() => {
    if (userData?.language) {
      i18n.changeLanguage(userData.language).then(() => {
        if (userData.language !== localStorage.getItem(localStorageLanguageKey)) {
          if (userData.language) {
            localStorage.setItem(localStorageLanguageKey, userData.language)
          }
        }
      });
    }
  }, [userData])
  useEffect(() => {
    const language = localStorage.getItem(localStorageLanguageKey)
    if (language && (language===Languages[0] || language===Languages[1])) {
        i18n.changeLanguage(language);
    } else {
      i18n.changeLanguage(Languages[1]).then( () => { localStorage.setItem(localStorageLanguageKey, Languages[1])});
    }
  }, [])
  const changeLanguage = (iso: LanguagesType) => {
    i18n.changeLanguage(iso).then(() => {
      localStorage.setItem(localStorageLanguageKey, iso);
      if (userData) {
        userData.language = iso;
        updateUserData(userData)
      }
    });
  }

  return <I18Context.Provider value={{changeLanguage, i18n}}>
    {children}
  </I18Context.Provider>
}
export default i18n;

